var dom  = require("enyo/dom"),
    kind = require("enyo/kind");

require("enyo-ui");

/**
 * [AccelerateSupport]{@link enyo-ui.AccelerateSupport} implements an
 * `accelerate` flag. If the flag is `true`, it automatically add a css
 * transform to the control to ensure it's gpu-accelerated.
 *
 * @mixin enyo-ui.AccelerateSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.AccelerateSupport",

    /**
     * Whether to gpu-accelerate this controls' DOM Node.
     *
     * @name     accelerate
     * @type     {boolean}
     * @default  true
     * @memberof enyo-ui.AccelerateSupport
     * @public
     */

    /**
     * Evaluate acceleration support and accelerate control as needed.
     *
     * @memberof enyo-ui.AccelerateSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            // Default to not accelerated
            if (this.accelerate === undefined) {
                this.accelerate = false;
            }

            // Cancel acceleration if not supported by browser
            this.accelerate = dom.canAccelerate() ? this.accelerate : false;

            // Apply acceleration as needed
            this.accelerate && dom.accelerate(this, "0");
        };
    })

};
